import { TDealsFilters, TDealsResponse, TDealStatus, TCreateDealPayload } from "@/models/deals.model";
import { TDeal } from "@/models/deals.model";
import { TLeadCsvJob } from "@/models/leads.model";
import axios from "@utils/axios-instance";

export const getUserDeals = async (userId: number): Promise<TDealsResponse> => {
  const response = await axios.get(`/deal`, { params: { dealOwner: userId, catalog: true, pageSize: 1 } });
  return response.data;
};

export const getLeadDealsService = async (leadId: number): Promise<TDeal[]> => {
  const response = await axios.get(`/deal/lead/${leadId}`);
  return response.data;
};

// LEAD DEALS CSV EXPORT (queued jobs, one slot per lead)

// The backend answers 409 when an export of this lead's deals is already in progress.
export const startLeadDealsExport = async (leadId: number): Promise<{ message: string; jobId: number }> => {
  const response = await axios.post(`/lead/${leadId}/deals/export`, {});
  return response.data;
};

export const getLeadDealsCsvJobs = async (leadId: number): Promise<TLeadCsvJob[]> => {
  const response = await axios.get(`/lead/${leadId}/deals/jobs`);
  return response.data;
};

export const downloadLeadDealsCsvJob = async (leadId: number, jobId: number): Promise<string> => {
  const response = await axios.get(`/lead/${leadId}/deals/jobs/${jobId}/download`);
  return response.data;
};

export const sortDealsService = async (newOrder: number[]): Promise<void> => {
  await axios.patch(`/deal/order`, newOrder);
};

const save = async (data: TCreateDealPayload): Promise<TDeal> => {
  const { pipeline, ...payload } = data;
  const response = await axios.post(`/deal/${pipeline}`, payload);
  return response.data;
};

export const getDealByIdService = async (dealId: number): Promise<TDeal> => {
  const response = await axios.get(`/deal/${dealId}`);
  return response.data;
};

const getAll = async (filters: TDealsFilters): Promise<TDealsResponse> => {
  filters = Object.fromEntries(Object.entries(filters).filter(([, val]) => Boolean(val)));
  const queryString = new URLSearchParams(filters as Record<string, string>).toString();
  const response = await axios.get(`/deal?${queryString}`);
  return response.data;
};

const updateById = async (id: number, data: Partial<Omit<TDeal, "id">>): Promise<TDeal> => {
  const response = await axios.patch(`/deal/${id}`, data);
  return response.data;
};

const updateDealStatus = async (data: TDealStatus): Promise<TDealStatus> => {
  const { id, color, name, isClosedStatus } = data;
  const response = await axios.patch(`/deal/status/${id}`, { color, name, isClosedStatus });
  return response.data;
};

const saveDealStatus = async (data: { pipelineId: number } & Pick<TDealStatus, "name" | "color">): Promise<TDealStatus> => {
  const { pipelineId, ...payload } = data;
  const response = await axios.post(`/deal/${pipelineId}/status`, payload);
  return response.data;
};

const deleteDealStatus = async (id: number, newStatusId?: number): Promise<void> => {
  const payload = newStatusId ? { data: { newStatusId } } : undefined;
  await axios.delete(`/deal/status/${id}`, payload);
};

const deleteDeal = async (id: number): Promise<void> => {
  await axios.delete(`/deal/${id}`);
};


export default {
  getAll,
  save,
  updateById,
  updateDealStatus,
  saveDealStatus,
  deleteDealStatus,
  deleteDeal,
};
